import { useAuth0 } from '@auth0/auth0-react';
import { Button, Typography } from '@mui/material';
import { captureException } from '@sentry/react';
import { useSnackbar } from 'notistack';

import { useAuth } from 'shared/lib/auth/useAuth';
import { AuthLayoutTemplate } from 'shared/ui/AuthLayoutTemplate';

import { resendVerificationEmail } from './api';

export const UnverifiedEmail = () => {
  const { user, logout } = useAuth();

  const { enqueueSnackbar } = useSnackbar();

  const auth0 = useAuth0();

  const provider = auth0.user?.sub?.split('|')[0];
  const isMagicLink = provider === 'email';
  const titleText = isMagicLink ? 'Check your email for a sign in link' : 'Verify your email';
  const bodyText = isMagicLink ? (
    <>
      We sent an email with a one-time sign in link to <strong>{user?.email}</strong>. If you don't see an email, check
      your spam folder or resend the email.
    </>
  ) : (
    <>
      Check <strong>{user?.email}</strong> to verify your email address. If you don't see an email in your inbox, check
      your spam folder or resend the email.
    </>
  );

  function handleResendClick() {
    if (user !== null) {
      resendVerificationEmail(user.id)
        .then(() => {
          enqueueSnackbar('Email sent');
        })
        .catch((error) => {
          captureException(error);
        });
    }
  }

  function handleLogoutClick() {
    logout().catch((error) => {
      captureException(error);
    });
  }

  return (
    <AuthLayoutTemplate pageName="UnverifiedEmail">
      <div className="flex flex-col gap-6">
        <Typography className="font-bold" variant="h1">
          {titleText}
        </Typography>
        <Typography variant="body1">{bodyText}</Typography>

        <div className="flex gap-3">
          <Button variant="contained" color="primary" onClick={handleResendClick}>
            Resend email
          </Button>
        </div>

        <Typography className="text-grey60" variant="body2">
          Need help? Reach out to{' '}
          <a className="text-primary-main" href="mailto:support@truv.com">
            support@truv.com
          </a>
          .
        </Typography>
      </div>
    </AuthLayoutTemplate>
  );
};
